import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Injector, NgModule, Optional, SkipSelf } from '@angular/core';
import { ServiceLocator, services } from '../core/locator/service-locator';
import {
  TextsModule,
  SpurtzModule,
  SpeedtestReadingModule,
  MetronomeReadingModule,
  HidenseekReadingModule,
  FlashReadingModule,
  EightReadingModule,
  BreakReadingModule,
  BlindReadingModule,
  FlashCardsModule,
  MentalModule,
  ColumnsModule,
  MultiModule,
  WordsMemoryModule,
  TilesModule,
  NumberMemoryModule,
  NumAndLetterMemoryModule,
  MorewordsMemoryModule,
  MorelaxModule,
  ChainMemoryModule,
  PercentsModule,
  NumberSystemsModule,
  NodAndNokModule,
  MatrixModule,
  LogarithmsModule,
  FractionsModule,
  SlipMatricesModule,
  SchulteModule,
  ReactionModule,
  ProofreadingTestsModule,
  NeurobicModule,
  DoubleSchulteModule,
  BeeModule,
} from './index';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  exports: [
    // Speed Reading
    TextsModule,
    SpurtzModule,
    SpeedtestReadingModule,
    MetronomeReadingModule,
    HidenseekReadingModule,
    FlashReadingModule,
    EightReadingModule,
    BreakReadingModule,
    BlindReadingModule,

    // Menar
    FlashCardsModule,
    MentalModule,
    ColumnsModule,
    MultiModule,

    // Memory
    WordsMemoryModule,
    TilesModule,
    NumberMemoryModule,
    NumAndLetterMemoryModule,
    MorewordsMemoryModule,
    MorelaxModule,
    ChainMemoryModule,

    // Math
    PercentsModule,
    NumberSystemsModule,
    NodAndNokModule,
    MatrixModule,
    LogarithmsModule,
    FractionsModule,

    // Attention
    SlipMatricesModule,
    SchulteModule,
    ReactionModule,
    ProofreadingTestsModule,
    NeurobicModule,
    DoubleSchulteModule,
    BeeModule,
  ],
})
export class MiniGamesModule {
  constructor(@Optional() @SkipSelf() parentModule?: MiniGamesModule) {
    if (parentModule) {
      throw new Error('GamesModule is already loaded. Import it in the one module only');
    }
    ServiceLocator.injector = Injector.create({
      providers: Object.keys(services).map((key) => ({
        provide: services[key].provide,
        useClass: services[key].provide,
        deps: services[key].deps,
      })),
    });
  }
}
